import { endpoints } from 'api/endpoints'
import { GetArrayResponse, GetOneResponse } from 'interfaces/api.interfaces'
import { PromoGroup, PromoGroupBase } from 'interfaces/api/promoGroups.interfaces'
import { axios } from 'modules/axios'

const getAll = async (): GetArrayResponse<PromoGroup> => {
  const { data: response } = await axios.request<PromoGroup[]>({
    method: 'GET',
    url: endpoints.promoGroups.getAll(),
  })
  return response
}

const create = async (data: PromoGroupBase): GetOneResponse<PromoGroup> => {
  const { data: response } = await axios.request<PromoGroup>({
    method: 'POST',
    url: endpoints.promoGroups.create(),
    data,
  })
  return response
}

const update = async (id: number, data: PromoGroupBase): GetOneResponse<PromoGroup> => {
  const { data: response } = await axios.request<PromoGroup>({
    method: 'PATCH',
    url: endpoints.promoGroups.update(id),
    data,
  })
  return response
}

const remove = (id: number): Promise<void> =>
  axios.request({
    method: 'DELETE',
    url: endpoints.promoGroups.remove(id),
  })

export const promoGroupsApi = {
  create,
  getAll,
  update,
  remove,
}
